var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0629 12.1277C15.4854 9.22739 17.9826 7 21 7H49C52.3137 7 55 9.68629 55 13V34.5858V51C55 54.3137 52.3137 57 49 57H21C19.2972 57 17.7601 56.2907 16.668 55.1513C13.3839 55.4163 10.4967 52.981 10.2091 49.6936L7.50729 18.8116C7.21848 15.5105 9.66043 12.6003 12.9615 12.3115L15.0629 12.1277ZM15.3734 53.0884C15.1319 52.438 15 51.7344 15 51V40.5858V14.1408L13.1358 14.3039C10.9351 14.4964 9.30714 16.4366 9.49968 18.6373L12.2015 49.5193C12.3591 51.3207 13.6882 52.7395 15.3734 53.0884ZM53 32.5858L46.5355 26.1213C44.5829 24.1687 41.4171 24.1687 39.4645 26.1213L33.4178 32.168L35.6639 34.4142C36.0545 34.8047 36.0545 35.4379 35.6639 35.8284C35.2734 36.219 34.6403 36.219 34.2497 35.8284L32.0035 33.5822L32 33.5858L29.8284 31.4142C28.2663 29.8521 25.7337 29.8521 24.1716 31.4142L17 38.5858V13C17 10.7909 18.7909 9 21 9H49C51.2091 9 53 10.7909 53 13L53 32.5858ZM29.0038 23C31.2129 23 33.0038 21.2091 33.0038 19C33.0038 16.7909 31.2129 15 29.0038 15C26.7947 15 25.0038 16.7909 25.0038 19C25.0038 21.2091 26.7947 23 29.0038 23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.4a1b08740c295ff21c47378c27ea8dcb.svg";
export { ForwardRef as ReactComponent };